import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, PropType, nextTick } from "vue";
import InlineSvg from "vue-inline-svg";
import { useRoute } from "vue-router";


const __default__ = {
  name: "SelectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  contents: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  initialIndex: {
    type: Number,
    default: -1,
  },
},
  emits: ["onItemSelected", "hideModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "78375542-modalHeightPx": (modalHeightPx)
}))

const props = __props;

const emit = __emit;

const route = useRoute();

const showModal = ref(true);
const selectedIndex = ref(props.initialIndex);
const optionRefs = ref([]);

const onItemSelected = (index: number) => {
  route.meta.onBackHandlerList.pop();
  selectedIndex.value = index;
  showModal.value = false;
  emit("onItemSelected", index);
};

const hideModal = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  emit("hideModal");
};

const modalHeightPx = `${props.contents.length * 59}px`;

const focusOption = (idx: number) => {
  nextTick(() => {
    const el = optionRefs.value[idx] as HTMLElement | undefined;
    if (el) el.focus();
  });
};

const onKeyUp = (idx: number) => {
  if (idx > 0) {
    selectedIndex.value = idx - 1;
    focusOption(idx - 1);
  }
};

const onKeyDown = (idx: number) => {
  if (idx < props.contents.length - 1) {
    selectedIndex.value = idx + 1;
    focusOption(idx + 1);
  }
};

const onEsc = () => {
  hideModal();
};

onMounted(() => {
  route.meta.onBackHandlerList.push(hideModal);
  focusOption(selectedIndex.value >= 0 ? selectedIndex.value : 0);
});

const __returned__ = { props, emit, route, showModal, selectedIndex, optionRefs, onItemSelected, hideModal, modalHeightPx, focusOption, onKeyUp, onKeyDown, onEsc, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})